import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { haccpApi } from '../../haccpApi';

export const useBlob = (path) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) { setUrl(null); return undefined; }
    let indirizzo = null;
    let vivo = true;
    haccpApi.get(path, { responseType: 'blob' }).then((b) => { if (vivo) { indirizzo = URL.createObjectURL(b); setUrl(indirizzo); } }).catch(() => vivo && setUrl(''));
    return () => { vivo = false; if (indirizzo) URL.revokeObjectURL(indirizzo); };
  }, [path]);
  return url;
};

const sposta = (box, y, x) => {
  const h = box ? box[2] - box[0] : 50;
  const w = box ? box[3] - box[1] : 260;
  const y0 = Math.min(Math.max(y - h / 2, 0), 1000 - h);
  const x0 = Math.min(Math.max(x - w / 2, 0), 1000 - w);
  return [Math.round(y0), Math.round(x0), Math.round(y0 + h), Math.round(x0 + w)];
};

// Pagina del documento con lo spazio della firma: un tocco sposta la firma in quel punto
export const PaginaFirma = ({ documentoId, pagina, box, onBox, anteprima }) => {
  const url = useBlob(`/documenti/firme/${documentoId}/pagina/${pagina}`);
  const tocca = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    onBox(sposta(box, ((e.clientY - r.top) / r.height) * 1000, ((e.clientX - r.left) / r.width) * 1000));
  };
  if (url === null) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-gray-400" /></div>;
  if (!url) return <p className="text-sm text-red-700">Pagina non disponibile.</p>;
  return (
    <div className="relative rounded-lg overflow-hidden border border-gray-300 cursor-pointer select-none" style={{ background: '#fff' }} onClick={tocca} data-testid="firma-pagina">
      <img src={url} alt={`Pagina ${pagina}`} className="w-full block" draggable={false} />
      {box && (
        <div className="absolute border-2 border-sky-500 rounded flex items-end justify-center pointer-events-none" data-testid="firma-pagina-box"
          style={{ top: `${box[0] / 10}%`, left: `${box[1] / 10}%`, height: `${(box[2] - box[0]) / 10}%`, width: `${(box[3] - box[1]) / 10}%`, background: 'rgba(14,165,233,0.12)' }}>
          {anteprima && <img src={anteprima} alt="Firma" className="max-h-full max-w-full object-contain" />}
        </div>
      )}
    </div>
  );
};
